import React from 'react';
import '../resetPassword.css'
import {ResetPassword} from "./resetPassword";
import LogoEmpreinte  from "../../../assets/LogoEmpreinte.webp";


export const FormResetPassword =()=>{


    return(
        <div className='Connection-form-reset-pass'>
        <div className="image-container-login">
                <img src={LogoEmpreinte} alt="img-contaoner-login" />
            </div>
            <ResetPassword/>
        </div>
    )
}
